import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { fetchPlaceAddress, type PlaceAddress } from '../api/geocodingApi';

// Imperative, since a place resolves on pick, not on render. Cached per placeId, no retry (quota).
export const usePlaceAddress = () => {
  const queryClient = useQueryClient();
  return useCallback(
    (placeId: string): Promise<PlaceAddress | null> =>
      queryClient.fetchQuery({
        queryKey: ['geocoding', 'place', placeId],
        queryFn: () => fetchPlaceAddress(placeId),
        retry: false,
        staleTime: 5 * 60_000,
      }),
    [queryClient]
  );
};
